import PropTypes from 'prop-types';
import { CustomSelect } from './CustomSelect.js';

const OPTION_GROUPS = [
  {
    label: 'Architecture',
    options: [
      { value: 'Deplacement', label: 'Déplacement' },
      { value: 'Remploi', label: 'Remploi' },
    ],
  },
  {
    label: 'Objets mobiliers',
    options: [
      { value: 'LieuExecution', label: "Lieu d'exécution renseigné" },
      { value: 'Origine', label: "Lieu d'origine renseigné" },
      { value: 'DeplacementObjet', label: 'Œuvre déposée, disparue ou volée' },
    ],
  },
];

const TypeEvenementField = ({ name, defaultValue, onChange }) => (
  <CustomSelect
    className="critere-input"
    value={defaultValue || null}
    name={name}
    onChange={onChange}
    options={OPTION_GROUPS}
  />
);
TypeEvenementField.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.shape({
    valeur: PropTypes.string,
    label: PropTypes.string,
    operateur: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
};

export default TypeEvenementField;
